import { createAction } from '@ngrx/store';

export const loadCorrespondenceDetails = createAction(
  '[Communication Address] Load'
);
export const loadConsents = createAction('[Consents] Load');
